export const STATE_HIDDEN = 'hidden';
export const STATE_CONTENTS = 'contents';
export const STATE_CONTACT = 'contact';
export const STATE_DELIVERY = 'delivery';
export const STATE_PAYMENT = 'payment';
export const STATE_SUMMARY = 'summary';
export const STATE_ORDERED = 'ordered';